import apiClient from './apiClient';

// Executions API
export const addExecution = async (tradeId, executionData) => {
  const response = await apiClient.post(`/trades/${tradeId}/executions`, executionData);
  return response.data;
};

export const getExecutionsForTrade = async (tradeId, options = {}) => {
  const params = new URLSearchParams();
  if (options.limit) params.append('limit', options.limit);
  if (options.nextToken) params.append('nextToken', options.nextToken);
  
  const response = await apiClient.get(`/trades/${tradeId}/executions?${params}`);
  return response.data;
};

export const getAccountExecutions = async (options = {}) => {
  const params = new URLSearchParams();
  if (options.limit) params.append('limit', options.limit);
  if (options.nextToken) params.append('nextToken', options.nextToken);
  if (options.fromTs) params.append('fromTs', options.fromTs);
  if (options.toTs) params.append('toTs', options.toTs);
  
  const response = await apiClient.get(`/executions?${params}`);
  return response.data;
};

export const deleteExecution = async (executionId) => {
  const response = await apiClient.delete(`/executions/${executionId}`);
  return response.data;
};

// Adjustments API
export const addAdjustment = async (tradeId, adjustmentData) => {
  const response = await apiClient.post(`/trades/${tradeId}/adjustments`, adjustmentData);
  return response.data;
};

export const getAdjustmentsForTrade = async (tradeId) => {
  const response = await apiClient.get(`/trades/${tradeId}/adjustments`);
  return response.data;
};

// Trade State API
export const getTradeState = async (tradeId, mark = null) => {
  const params = new URLSearchParams();
  if (mark) params.append('mark', mark);
  
  const response = await apiClient.get(`/trades/${tradeId}/state?${params}`);
  return response.data;
};

// Trade Events API
export const linkEventToTrade = async (tradeId, eventData) => {
  const response = await apiClient.post(`/trades/${tradeId}/events`, eventData);
  return response.data;
};

export const getTradeEvents = async (tradeId) => {
  const response = await apiClient.get(`/trades/${tradeId}/events`);
  return response.data;
};



export const checkAndCloseTrade = async (tradeId) => {
  const response = await apiClient.post(`/trades/${tradeId}/check-close`);
  return response.data;
};
